import { request } from "../../utils/config"

export const UPDATE_CURRENCY_RATE = async (data: { uzs: number }) => {
  const response = await request({
    url: `Helpers/MainUSDvsUZS?uzs=${data.uzs}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const FETCH_CBU_RATE = async () => {
  const response = await request({
    url: `Helpers/FetchRateFromCBU`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const SET_AUTO_FETCH_CBU = async (autoFetch: boolean) => {
  const response = await request({
    url: `Helpers/SetAutoFetchCBU?autoFetch=${autoFetch}`,
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
